module.exports = __webpack_public_path__ + "img/login2.d814adb7.png";